import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/hero2.png")